"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportStepFinished = exports.ExportStepFinishedWithoutAttachment = exports.ExportStepStart = void 0;
exports.ExportStepStart = 0;
exports.ExportStepFinishedWithoutAttachment = 65534;
exports.ExportStepFinished = 65535;
